const ContactForm: React.FC = () => {
  return <></>;
};

export default ContactForm;
